import * as Sentry from "@sentry/browser"

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content
const environment = document.querySelector('meta[name="environment"]')?.content
const release = document.querySelector('meta[name="release"]')?.content

if (dsn) {
  const isNative = /Turbo Native/.test(navigator.userAgent)

  Sentry.init({
    dsn,
    environment,
    release,
    initialScope: {
      tags: { hotwire_native: isNative }
    }
  })
}
